module.exports = __webpack_public_path__ + "static/media/chuyinshan_plant.d07180ed.webp";